export default (url, ...paths) => {
    return paths.some((path) => {
        const regString = path
            .replaceAll("/", "\\/")
            .replaceAll(/:[^/]+/g, ".+");
        return new RegExp(regString).test(url);
    });
};
